module.exports = __webpack_public_path__ + "img/ring_r_skip_1_1.463b321a.png";